var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section')
    }
  }), _vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _vm.deepGet(_vm.bookingPreset, 'config.content_page.banner_image') && (_vm.currentPageNumber === 0 || _vm.deepGet(_vm.bookingPreset, 'config.content_page.displayed_in_every_page', false)) ? _c('img', {
    staticClass: "banner-image w-100",
    attrs: {
      "src": _vm.deepGet(_vm.bookingPreset, 'config.content_page.banner_image')
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page",
    style: "background-image: url(".concat(_vm.deepGet(_vm.bookingPreset, 'config.content_page.background_image', ''), ")")
  }, [_c('div', {
    staticClass: "p-3 liff-reservation-form"
  }, [_vm.currentPageNumber === 0 || _vm.deepGet(_vm.bookingPreset, 'config.content_page.displayed_in_every_page', false) ? [_vm.deepGet(_vm.bookingPreset, 'config.content_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.bookingPreset, 'config.content_page.form_title')) + " ")]) : _vm._e(), _vm.deepGet(_vm.bookingPreset, 'config.content_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.bookingPreset, 'config.content_page.form_desc')) + " ")]) : _vm._e(), _vm.deepGet(_vm.bookingPreset, 'config.content_page.content') ? _c('div', {
    staticClass: "page__content mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.bookingPreset, 'config.content_page.content'))
    }
  }) : _vm._e()] : _vm._e(), _vm.hasDefaultPage && _vm.currentPageNumber === 0 ? [false === _vm.hasSetUpFieldMappingForStartAt ? _c('SubjectLayout', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "subject": _vm.subjectForStartAt
    }
  }, [_c('DatePicker', {
    attrs: {
      "to-first-second": true
    },
    model: {
      value: _vm.start_at,
      callback: function callback($$v) {
        _vm.start_at = $$v;
      },
      expression: "start_at"
    }
  })], 1) : _vm._e(), false === _vm.hasSetUpFieldMappingForEndAt ? _c('SubjectLayout', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "subject": _vm.subjectForEndAt
    }
  }, [_c('DatePicker', {
    attrs: {
      "to-last-second": true
    },
    model: {
      value: _vm.end_at,
      callback: function callback($$v) {
        _vm.end_at = $$v;
      },
      expression: "end_at"
    }
  })], 1) : _vm._e()] : _vm._e(), _c('DynamicForm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoading,
      expression: "!isLoading"
    }],
    key: _vm.currentPageNumber,
    ref: "dynamicForm",
    attrs: {
      "input-subjects": _vm.subjectsOfCurrentPageWithoutSection,
      "validation-filter": _vm.onlySubjectsInCurrentPage,
      "optionDisabler": _vm.optionDisabler,
      "branchFetching": _vm.isFetchingBranch,
      "phone-verification-config": _vm.phoneVerificationConfig
    },
    on: {
      "outputBranchSelectResult": _vm.handleBranchSelectResult,
      "file-uploading": _vm.updateFileUploading,
      "diff": _vm.handleDynamicFormDataChanged
    },
    model: {
      value: _vm.dynamicFormInput,
      callback: function callback($$v) {
        _vm.dynamicFormInput = $$v;
      },
      expression: "dynamicFormInput"
    }
  }), _vm._l(_vm.sectionsOfCurrentPage, function (section, i) {
    return _c('b-card', {
      key: "section".concat(i, "page").concat(_vm.currentPageNumber),
      staticClass: "mt-4 liff-reservation-form__card",
      attrs: {
        "header-tag": "header"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn() {
          return [_c('div', {
            staticClass: "d-flex justify-content-between align-items-center"
          }, [_c('h6', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(section.title))])])];
        },
        proxy: true
      }], null, true)
    }, [_c('DynamicForm', {
      key: _vm.currentPageNumber,
      ref: "dynamicFormForSection",
      refInFor: true,
      attrs: {
        "input-subjects": _vm.subjectsOfCurrentSection(section),
        "optionDisabler": _vm.optionDisabler,
        "phone-verification-config": _vm.phoneVerificationConfig
      },
      on: {
        "outputBranchSelectResult": _vm.handleBranchSelectResult,
        "diff": _vm.handleDynamicFormDataChanged
      },
      model: {
        value: _vm.dynamicFormInput,
        callback: function callback($$v) {
          _vm.dynamicFormInput = $$v;
        },
        expression: "dynamicFormInput"
      }
    })], 1);
  }), _vm.visiblePages.length > 1 ? _c('div', {
    staticClass: "step-indicator my-4"
  }, _vm._l(_vm.visiblePages.length, function (index) {
    return _c('div', {
      key: index,
      staticClass: "step-indicator__step",
      class: {
        'step-indicator__step--filled': index <= _vm.currentPageNumber + 1,
        'step-indicator__step--current': index === _vm.currentPageNumber + 1
      }
    });
  }), 0) : _vm._e(), _vm.failedAvailabilityCheck ? _c('p', {
    staticClass: "text-danger text-center mt-4"
  }, [_vm._v(_vm._s(_vm.fullAlertText))]) : _vm._e(), !_vm.isFetchingLeaveShifts && _vm.selectedTimeIsOffDuty ? _c('p', {
    staticClass: "text-danger text-center mt-4"
  }, [_vm._v("該時段涵蓋了非營業時間，請重新選取時間")]) : _vm._e(), _vm.startTimeHasInsufficientBookingWindow ? _c('p', {
    staticClass: "text-danger text-center mt-4"
  }, [_vm._v("只能預約" + _vm._s(_vm.bookingWindowConfigForDisplay) + "以內的時段")]) : _vm._e(), _vm.startTimeHasInsufficientLeadTime ? _c('p', {
    staticClass: "text-danger text-center mt-4"
  }, [_vm._v(_vm._s(_vm.leadTimeErrorMessage))]) : _vm._e(), _vm.startDateIsOnHoliday ? _c('p', {
    staticClass: "text-danger text-center mt-4"
  }, [_vm._v("該店於 " + _vm._s(_vm.dateOfStartAt) + " 公休")]) : _vm._e(), !_vm.startDateIsOnHoliday && _vm.startTimeIsOutOfBusinessHours ? _c('p', {
    staticClass: "text-danger text-center mt-4"
  }, [_vm._v("該店在 " + _vm._s(_vm.dateOfStartAt) + " 的營業時間為 " + _vm._s(_vm.businessHoursOfStartDate))]) : _vm._e(), _vm.endDateIsOnHoliday ? _c('p', {
    staticClass: "text-danger text-center mt-4"
  }, [_vm._v("該店於 " + _vm._s(_vm.dateOfEndAt) + " 公休")]) : _vm._e(), !_vm.endDateIsOnHoliday && _vm.endTimeIsOutOfBusinessHours ? _c('p', {
    staticClass: "text-danger text-center mt-4"
  }, [_vm._v("該店在 " + _vm._s(_vm.dateOfEndAt) + " 的營業時間為 " + _vm._s(_vm.businessHoursOfEndDate))]) : _vm._e(), _c('div', {
    staticClass: "d-flex s-space-x-2 mt-4"
  }, [_vm.currentPageNumber !== 0 ? _c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    on: {
      "click": _vm.returnToPreviousStep
    }
  }, [_vm._v(" 上一步 ")]) : _vm._e(), _vm.currentPageNumber + 1 !== _vm.visiblePages.length ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": _vm.showingLoadingForNextStepButton || _vm.bookingIsInvalid,
      "isLoading": _vm.showingLoadingForNextStepButton
    },
    on: {
      "click": _vm.proceedToNextStep
    }
  }, [_vm._v(" 下一步 ")]) : _vm._e(), _vm.currentPageNumber + 1 === _vm.visiblePages.length ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": !_vm.isCanEdit || _vm.showingLoadingForNextStepButton || _vm.bookingIsInvalid,
      "isLoading": _vm.showingLoadingForNextStepButton
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.bookingPreset, 'config.content_page.submit_button_text')) + " ")]) : _vm._e()], 1)], 2)])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }